<template>
  <div class="pd-top-15">
    <page-layout
      :breadcrumbs="[
        {
          text: this.$t('navDrawer.home').toUpperCase(),
          disabled: false,
          to: {name: 'home'},
          exact: true
        },
        {
          text: localization.title.toUpperCase(),
          disabled: true
        }
      ]"
    >
      <v-row justify="center" align="center" no-gutters>
        <v-col cols="12">
          <v-form v-model="valid" id="valid" ref="form">
            <o-big-title justify="start"><slot name="title">{{localization.datosVisita.title}}</slot></o-big-title>
            <v-col>
              <v-row wrap align="center" no-gutters>
                <v-col cols="4" md="3" class="pl-3 pr-3">
                  
                  <v-autocomplete v-if="rolProveedor" :no-data-text="$t('sinDatos')" v-model="promSelected" id="promSelected" :items="promocionesProveedor"
                    item-value="id" item-text="name" :label="localization.datosVisita.promocion"
                    :disabled="!visitTypes" :rules="[rules.obligatorio]">
                      <template v-slot:selection="data">
                        {{ pintarPromocion(data) }}
                      </template>
                      <template v-slot:item="data">
                        {{ pintarPromocion(data) }}
                      </template>
                  </v-autocomplete>
                  <v-autocomplete v-else :no-data-text="$t('sinDatos')" v-model="promSelected" id="promSelected" :items="promociones"
                    item-value="id" item-text="nombreCompleto" :label="localization.datosVisita.promocion"
                    :disabled="!visitTypes" :rules="[rules.obligatorio]">
                      <template v-slot:selection="data">
                        {{ pintarPromocion(data) }}
                      </template>
                      <template v-slot:item="data">
                        {{ pintarPromocion(data) }}
                      </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="6" class="pl-3 pr-3">
                  <div v-if="!rolProveedor" @click="promSelected ? mostrarSeleccionarInmuebles = true : null" :style="promSelected ? 'cursor: pointer' : ''">
                    <v-autocomplete :no-data-text="$t('sinDatos')"
                      v-model="inmueblesSeleccionadosConId" id="inmueblesSeleccionadosConId"
                      :items="inmuebleConDatos"
                      :label="localization.datosVisita.inmuebles"
                      item-value="id"
                      readonly
                      multiple
                      append-icon="none"
                    >
                      <template slot="selection" slot-scope="data">
                        <!-- HTML that describe how select should render selected items -->
                        {{ traducirInmuebleSeleccionado(data.item) }}
                      </template>
                      <template slot="item" slot-scope="data">
                        <!-- HTML that describe how select should render items when the select is open -->
                        {{ traducirInmuebleSeleccionado(data.item) }}
                      </template>
                    </v-autocomplete>
                  </div>
                  
                  <v-autocomplete v-else :no-data-text="$t('sinDatos')" v-model="inmuebleSelected" id="inmuebleSelected" :items="inmueblesProveedor"
                    item-value="id" item-text="nombreCompleto" :label="localization.datosVisita.inmuebles"
                    :disabled="!visitTypes" :rules="[rules.obligatorio]">
                      <template v-slot:selection="data">
                        {{ (data.item.alias || data.item.uhedit)}}
                      </template>
                      <template v-slot:item="data">
                        {{ (data.item.alias || data.item.uhedit)}}
                      </template>
                  </v-autocomplete>
                </v-col>
                <v-col class="pl-3 pr-3" v-if="!rolProveedor">
                  <v-btn
                    class="ml-6"
                    color="primary"
                    large
                    @click="mostrarSeleccionarInmuebles = true"
                    :disabled="!promSelected"
                  >
                    {{localization.datosVisita.inmueblesButton}}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row wrap no-gutters> 
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <o-date-picker
                    v-model="visitDate" id="visitDate"
                    :label="localization.datosVisita.fechaVisita"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <v-autocomplete :no-data-text="$t('sinDatos')"
                    v-model="tipoVisita" id="tipoVisita"
                    :items="tiposVisitaFiltrados"
                    :item-text="item => `${ item.translates && item.translates[usuario.idioma] !== undefined && item.translates[usuario.idioma] !== null ? item.translates[usuario.idioma] : ''  }`"
                    item-value="id"
                    :label="localization.datosVisita.tipoVisita"
                    :readonly="inmueblesSeleccionados.length === 0"
                    :rules="[rules.obligatorio]"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <v-text-field 
                    v-model="reportedBy" id="reportedBy"
                    :label="localization.datosVisita.reportadoPor"
                  />
                </v-col>
              </v-row>


              <!-- Nuevos campos 294972 -->

              <v-row wrap no-gutters> 
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3" v-if="getConfiguracion.PV_VISITA_FECHA_ALTA_CLIENTE">
                  <o-date-picker
                    v-model="clientDate" id="clientDate"
                    :label="localization.datosVisita.altaInquilino"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3"  v-if="getConfiguracion.PV_VISITA_REGISTRO_ENTRADA">
                  <v-text-field 
                    v-model="entryRegister" id="entryRegister"
                    :label="localization.datosVisita.registroEntrada"
                    maxlength="15"
                  />
                </v-col>
              </v-row>

            </v-col>
            <o-big-title justify="start"><slot name="title">{{localization.contactoVisita.title}}</slot></o-big-title>
            <v-col>
              <v-row v-if="comprobarEspecial" justify="center" no-gutters>
                <v-col cols="12" md="6">
                  <v-row align="center">
                    <v-col cols="8">
                      <div @click="mostrarSeleccionarClientesEsp = true" :style="'cursor: pointer'">
                        <v-autocomplete :no-data-text="$t('sinDatos')"
                          v-model="clienteSeleccionado" id="clienteSeleccionado"
                          :items="clienteSeleccionado"
                          :label="localization.contactoVisita.clientesEspeciales"
                          item-value="id"
                          multiple
                          readonly
                          append-icon="none"
                          :rules="[rules.required]"
                        >
                        <template slot="selection" slot-scope="data">
                          <!-- HTML that describe how select should render selected items -->
                          {{ traducirClienteEspecialSeleccionado(data.item) }}
                        </template>
                        <template slot="item" slot-scope="data">
                          <!-- HTML that describe how select should render items when the select is open -->
                          {{ traducirClienteEspecialSeleccionado(data.item) }}
                      </template>
                        </v-autocomplete>
                      </div>
                    </v-col>
                    <v-col class="pl-3 pr-3">
                      <v-btn
                        class="ml-6"
                        color="primary"
                        large
                        @click="mostrarSeleccionarClientesEsp = true"
                        :disabled="!clientesEspeciales"
                      >
                        {{localization.contactoVisita.clientesEspecialesButton}}
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row wrap no-gutters>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <v-text-field
                    v-model="name" id="name"
                    :label="localization.contactoVisita.nombre"
                    :rules="[rules.max(60)]"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <v-text-field
                    v-model="phone" id="phone"
                    :label="localization.contactoVisita.telefono"
                    :rules="[rules.phoneNumber]"
                  />
                </v-col>
                <v-col cols="12" md="4" lg="4" class="pl-3 pr-3">
                  <v-text-field
                    v-model="mobile" id="mobile"
                    :label="localization.contactoVisita.movil"
                    :rules="[rules.phoneNumber]"
                  />
                </v-col>
              </v-row>
              <v-row wrap no-gutters>
                <v-col cols="12" md="6" lg="6" class="pl-3 pr-3">
                  <v-text-field
                    v-model="email" id="email"
                    :label="localization.contactoVisita.email"
                    :rules="[rules.email]"
                  />
                </v-col>
                <v-col cols="12" md="6" lg="6" class="pl-3 pr-3">
                  <v-text-field
                    v-model="observations" id="observations"
                    :label="localization.contactoVisita.observaciones"
                    maxlength="100"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-col>
      </v-row>
      <v-row class="btnSet" justify="center" no-gutters>
        <v-btn 
          @click="create()"
          color="primary"
        >
          {{localization.button}}
        </v-btn>
      </v-row>
      <v-fade-transition>
        <custom-dialog 
          v-if="mostrarSeleccionarInmuebles" 
          v-model="mostrarSeleccionarInmuebles" id="mostrarSeleccionarInmuebles"
          @aceptar="mostrarSeleccionarInmuebles = $event"
        >
          <PopUpSeleccionarInmuebles
            @selected="inmueblesSeleccionados = $event"
            @empezar="empezarEspeciales = $event"
            :yaSeleccionado="inmueblesSeleccionados"
            :promoId="promSelected"
            :multiple="true"
            :especiales="empezarEspeciales"
          />
        </custom-dialog>
      </v-fade-transition>
      <v-fade-transition>
        <custom-dialog 
          v-if="mostrarSeleccionarClientesEsp" 
          v-model="mostrarSeleccionarClientesEsp" id="mostrarSeleccionarClientesEsp"
          @aceptar="mostrarSeleccionarClientesEsp = $event"
        >
          <PopUpSeleccionarClientesEsp
            @clienteSelected="clienteSeleccionado = $event"
            :clienteYaSeleccionado="clienteSeleccionado"
            :promoId="promSelected"
          />
        </custom-dialog>
      </v-fade-transition>
    </page-layout>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'
import PopUpSeleccionarInmuebles from './PopUpSeleccionarInmuebles'
import PopUpSeleccionarClientesEsp from './PopUpSeleccionarClientesEsp'

export default {
  mixins: [rulesMixin],
  props: {
    codigoTipo: {
      type: String,
      default: null
    }
  },
  components: {
    PopUpSeleccionarInmuebles,
    PopUpSeleccionarClientesEsp
  },
  data () {
    return {
      codigoTipoSolicitudes: null,
      valid: false,
      reportedBy: null,
      name: null,
      phone: null,
      mobile: null,
      email: null,
      observations: null,
      visitDate: moment().format('YYYY-MM-DD'),
      clientDate: null,
      entryRegister: null,
      tipoVisita: null,
      promSelected: null,
      inmueblesSeleccionados: [],
      menu: false,
      mostrarSeleccionarInmuebles: false,
      mostrarSeleccionarClientesEsp: false,
      clientesEspeciales: true,
      clienteSeleccionado: [],
      waitingForLoad: false,
      loader: null,
      tiposVisitaFiltrados: [],
      empezarEspeciales: false,
      visitToGo: null,
      allVisitIds: [],
      promocionesProveedor: [],
      inmueblesProveedor: [],
      inmuebleSelected: null
    }
  },
  mounted () {
    this.loader = this.$loading.show({
      // Optional parameters
      container: this.fullPage ? null : this.$refs.formContainer,
      canCancel: false,
      onCancel: this.onCancel
    })
        
    this.validarTipoSolicitudes()
    this.load()
  },
  computed: {
    ...mapGetters({
      getterVisita: 'incidencias/getVisita',
      getConfiguracion: 'configuracion/getConfiguracion',
      tiposSolicitud: 'configuracion/getTiposSolicitud',
      idubapi: 'login/idubapi',
      rolProveedor: 'login/rolProveedor'
    }),
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
    translates() {
      if (this.$store.state.tiposSolicitud.translates) {
        return this.$store.state.tiposSolicitud.translates;
      }
      return [];
    },
    localization () {
      return this.$t('sectionNuevaVisita')
    },
    inmueblesSeleccionadosConId () {
      return this.inmueblesSeleccionados.map(x => {
        return {
          ...x,
          id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId
        }
      })
    },
    visitTypes () {
      if (this.$store.state.incidencias.tipoVisita) {
        return this.$store.state.incidencias.tipoVisita
      }
      return []
    },
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    actualVisitId () {
      if (this.$store.state.incidencias.actualVisitId) {
        return this.$store.state.incidencias.actualVisitId
      }
      return null
    },
    comprobarEspecial () {
      if (!this.rolProveedor && this.inmueblesSeleccionados && this.inmueblesSeleccionados.some(x => x.inmuebleEspecialId !== null)) {
        return true
      } else {
        return false
      }
    },
    visitDateFormated () {
      return (this.visitDate) ? moment(this.visitDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    clientDateFormated () {
      return (this.clientDate) ? moment(this.clientDate, 'YYYY-MM-DD').format('DD/MM/YYYY') : null
    },
    inmuebleConDatos () {
      // let itemsArray = []
      // itemsArray.push(item)
      return this.inmueblesSeleccionados.map(x => {
        return {
          ...x,
          id: x.inmuebleId != null ? x.inmuebleId: x.inmuebleEspecialId,
          inmuebleSeleccionadoDesc: x.uhedit
        }
      })
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getVisit: 'incidencias/getVisit',
      getVisitTypes: 'incidencias/getVisitTypes',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      loadConfiguracion: 'configuracion/obtenerConfiguracion',
      addVisit: 'incidencias/addVisit',
      obtenerPromocionesProveedor: 'incidencias/obtenerPromocionesProveedor',
      obtenerInmueblesProveedor: 'incidencias/obtenerInmueblesProveedor'
    }),
    validarTipoSolicitudes () {
      const tipo = this.$route.query.codigoTipoSolicitudes
      if (tipo !== undefined && tipo !== null) {
        if (this.tiposSolicitud.find(x => x.codigoTipoSolicitud.toString() === tipo.toString()) === undefined) {
          this.addAlert({ texto: this.$t('sinPermisosParaAcceder'), color: 'error' })
          this.$router.push('home')
          this.loader.hide()
        }
        this.codigoTipoSolicitudes = tipo
      } else {
        this.codigoTipoSolicitudes = null
      }
    },
    async create () {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({texto: this.$t("revisarCamposRojo"), color: 'error'})
      } else {
        try {
          await Promise.all(this.inmueblesSeleccionados.map(async x => {
            console.log(x)
            
            let newVisit = {
              date: this.visitDate,
              reportedBy: this.reportedBy,
              visitTypeId: this.tipoVisita,
              contactName: this.name,
              contactTlf: this.phone,
              contactTlf2: this.mobile,
              contactEmail: this.email,
              contactObs: this.observations,
              specialCostumerId: this.clienteSeleccionado.length > 0 ? this.clienteSeleccionado[0].id : null,
              developmentId: this.promSelected,
              propertyId: x.inmuebleId,
              specialPropertyId: x.inmuebleEspecialId ?? null,
              operationId: x.operacionId,
              clientDate: this.clientDate,
              entryRegister: this.entryRegister
            }
            let response = await this.addVisit(newVisit)
            this.visitToGo = response
            this.allVisitIds.push(response)
          }))
          await this.$router.push({name: 'datosVisita', params: {actualVisitId: this.visitToGo, allVisitIds: this.allVisitIds, codigoSolicitudEnRuta: this.codigoTipo}})
        } catch (error) {
          this.loader.hide()
          this.addAlert({ texto: this.$t('errorCrearVisita') + error.message, color: 'error' })
        }
      }
      this.loader.hide()
    },
    load () {
      this.$store.commit('incidencias/setAllIncidences', [])
      this.loadConfiguracion()
      this.getVisitTypes()
      
      if(this.rolProveedor) {
        // si es rol proveedor vamos a sacar las promos e inmuebles
        this.obtenerPromocionesProveedor()
        .then(result => {
          
          if(result.data.data.length > 0) {
            this.promocionesProveedor = result.data.data
          }
          
          this.waitingForLoad = false
          this.loader.hide()
        })
        .catch((error) => {
            if (!error.code || error.code !== 1) {
              this.waitingForLoad = false
              this.addAlert({texto: error.message, color: 'error'})
            }
            this.loader.hide()
          })
      } else {
        this.getPropertiesDevelopment()
          .then(() => {
            this.waitingForLoad = false
            this.loader.hide()
          })
          .catch((error) => {
            if (!error.code || error.code !== 1) {
              this.waitingForLoad = false
              this.addAlert({texto: error.message, color: 'error'})
            }
            this.loader.hide()
          })
      }
        
    },
    formatDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    getTiposVisitaPorAmbito () {
      if (this.comprobarEspecial) {
        this.tiposVisitaFiltrados = this.visitTypes
      } else  {
        if (this.inmueblesSeleccionados.length === 1) {
          let ambito = this.inmueblesSeleccionados[0].ambito

          // 283946 - Se mira la config que viene en el usuario:
          // entornos.0.PERMISOS_ACTOR_VISITAS_PV
          
          let configuracion = this.idubapi.PERMISOS_ACTOR_VISITAS_PV

          const tiposIncidenciaAlquiler = [
            (configuracion.PV_TIPO_INCIDENCIA_ALQ.includes('1')) ? 1 : '',
            (configuracion.PV_TIPO_INCIDENCIA_ALQ.includes('2')) ? 2 : '',
            (configuracion.PV_TIPO_INCIDENCIA_ALQ.includes('3')) ? 3 : ''
          ]
          const tiposIncidenciaSinOperacion = [
            (configuracion.PV_TIPO_INCIDENCIA_SIN_OPER.includes('1')) ? 1 : '',
            (configuracion.PV_TIPO_INCIDENCIA_SIN_OPER.includes('2')) ? 2 : '',
            (configuracion.PV_TIPO_INCIDENCIA_SIN_OPER.includes('3')) ? 3 : ''
          ]

          const tiposIncidenciaVenta = [
            (configuracion.PV_TIPO_INCIDENCIA_VTA.includes('1')) ? 1 : '',
            (configuracion.PV_TIPO_INCIDENCIA_VTA.includes('2')) ? 2 : '',
            (configuracion.PV_TIPO_INCIDENCIA_VTA.includes('3')) ? 3 : ''
          ]
          
          if (ambito === '1') {
            this.tiposVisitaFiltrados = []
            tiposIncidenciaVenta.forEach(x => {
              let tipo = this.visitTypes.find(j => j.code == x)
              this.tiposVisitaFiltrados.push(tipo)
            })
          } else if (ambito === '2') {
            this.tiposVisitaFiltrados = []
            tiposIncidenciaAlquiler.forEach(x => {
              let tipo = this.visitTypes.find(j => j.code == x)
              this.tiposVisitaFiltrados.push(tipo)
            })
          } else {
            this.tiposVisitaFiltrados = []
            tiposIncidenciaSinOperacion.forEach(x => {
              let tipo = this.visitTypes.find(j => j.code == x)
              this.tiposVisitaFiltrados.push(tipo)
            })
          }
        } else if (this.inmueblesSeleccionados.length > 1) {
          this.tiposVisitaFiltrados = this.visitTypes
        }
      }
      
      return this.tiposVisitaFiltrados
    },
    pintarPromocion(item) {
      // if(this.rolProveedor) {
        let datosPromocion = item.item
        return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
      // } else {
      //   let datosPromocion = item.item
      //   return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
      // }
      
    },
    traducirInmuebleSeleccionado(item) {
      if(item) {
        if(item.inmuebleEspecialId === null) return item.inmuebleSeleccionadoDesc
        if(this.usuario.idioma === 'spa') {
          return item.inmuebleSeleccionadoDesc
        } else {
          let traducciones = JSON.parse(item.traduccion)
          if(traducciones) {
            return traducciones[this.usuario.idioma] || item.inmuebleSeleccionadoDesc
          } else {
            return item.inmuebleSeleccionadoDesc
          } 
        }
        
      } else {
        return null
      }
      

    },
    traducirClienteEspecialSeleccionado(item) {
      if(item) {
        if(this.usuario.idioma === 'spa') {
          return item.descripcion
        } else {
          let traducciones = JSON.parse(item.traduccion)
          if(traducciones) {
            return traducciones[this.usuario.idioma] || item.descripcion
          } else {
            return item.descripcion
          } 
        }
        
      } else {
        return null
      }
    }
  },
  watch: {
    inmueblesSeleccionados () {
      this.getTiposVisitaPorAmbito()
    },
    promSelected () {
      if(this.rolProveedor) {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel
        })
        
        this.obtenerInmueblesProveedor({
          propertyDevelopmentId: ( this.promSelected.length > 0 ?  [this.promSelected] : [])
        })
          .then(result => {
              
            if(result.data.data.length > 0) {
              this.inmueblesProveedor = result.data.data
            }
            
            this.waitingForLoad = false
            this.loader.hide()
          })

      }
      this.inmueblesSeleccionados = []
    },
    inmuebleSelected () {
      if(this.inmuebleSelected) {
        // obtenemos los datos del inmueble en base al cod seleciconado
        const inmueblesProveedor = this.inmueblesProveedor.map(item => {
          return {
            ...item,
            inmuebleId: item.inmuebleId,
            inmuebleEspecialId: item.inmuebleEspecialId,
            operacionId: item.operacionId
          }
          
        })
        const inmuebleSeleccionado = inmueblesProveedor.filter(item => {
          if(item.inmuebleEspecialId == null){
            return item.inmuebleId == this.inmuebleSelected.inmuebleId
          }else{
            return item.inmuebleEspecialId == this.inmuebleSelected.inmuebleEspecialId
          }
          
        });

        this.inmueblesSeleccionados = inmuebleSeleccionado
        
      } else {
        this.inmueblesSeleccionados = []
      }
      
    }
  }
}
</script>

<style>
.bigContainer {
  height: 90vh;
}

.v-select__selections {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-wrap: nowrap;
}
</style>
